import script from "./KubeconfigClusters.vue?vue&type=script&setup=true&lang=ts"
export * from "./KubeconfigClusters.vue?vue&type=script&setup=true&lang=ts"

import "./KubeconfigClusters.vue?vue&type=style&index=0&id=567fe7e3&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567fe7e3"]])

export default __exports__